import type { FaireProductEntity } from "../../entity_types/product";

export const p_8a7zmvv9xz: FaireProductEntity = {
  token: "p_8a7zmvv9xz",
  type: "product",
  name: "Mother's Day Candle 14oz -Light & Reveal Hidden Bible Verse",
  brandToken: "b_s435f7c5ne",
  brandName: "Lord's Light Candle",
  imageUrl:
    "https://cdn.faire.com/fastly/0d02f3378ee106c627156e4967b7db841772bef449e47fda592737c449e3a128.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9d1ab26a8640c63df3345ab3aeb95edc433feb2ed1dab2bb34a4ebd3f8e3e6cc.jpeg",
    "https://cdn.faire.com/fastly/93bfed7108abcf542f0eddd25133f963c355ab476ebfb01710c768f2a8e7531a.jpeg",
    "https://cdn.faire.com/fastly/8d379488d23f5b8ab598a69421253e3a5ac3b6e4f490374e37dcc04412f619eb.jpeg",
    "https://cdn.faire.com/fastly/6027b53cf7fd2b4c43614807eefb88a97620826485239ca897a62fe7647f51f8.jpeg",
    "https://cdn.faire.com/fastly/0a0835df3c43c12f39698852c6cdb43630daffe78efcbfa3554ec4ee92043ef5.jpeg",
    "https://cdn.faire.com/fastly/3d86dd1cf9f907b1d3c39aca5165958edc892a77a4d4660d586f18d3c86254f2.jpeg",
    "https://cdn.faire.com/fastly/d9e26e7586b90dd0ce3d5c7441d1f3f7c6446b5ff8b0b3d4fadd2edaa35ae050.jpeg",
    "https://cdn.faire.com/fastly/895dcb5ddbfe033ccdf418fdec05b67f98484867400d938182895fd936f23a73.jpeg",
    "https://cdn.faire.com/fastly/4dcfcc025132c0eafb893a678178909fdcc799cb90849c53e7a02db8cbb56d65.jpeg",
    "https://cdn.faire.com/fastly/84193636242d0d49c8e6b2bb32dd2091881b2f4494f28dccf7fa3c33cd33c526.jpeg",
    "https://cdn.faire.com/fastly/78f018fb8277dcf1b40f13f6efff4753ad4da7035cb563cbaba746dc61414f68.jpeg",
    "https://cdn.faire.com/fastly/554acaf96bedaff524a038daa1c4fafd635bf25e04f4826f9276ff81249e0e70.jpeg",
  ],
  priceDollars: 16,
  description:
    "This is not just another candle. Hand-poured with natural soy-coconut wax and infused with premium, inviting fragrances, this candle transforms any space into a peaceful sanctuary.\n\nBut the true beauty? As the candle burns, the warmth of the flame slowly changes the band at the top of the jar, revealing Proverbs 31:28, \"Her children will rise up and call her blessed.\"  It beautifully honors a mother's love, celebrating how her children rise up to praise her for all she does.  It's more than just a candle —  this is the unique, meaningful gift your shoppers are looking for.\n\nHighlights:\n - 14 oz natural soy-coconut wax with a clean burn up to 58 hrs\n - Dye, phthalate & paraben free\n - Premium essential & fragrance oils\n - Hand-poured in small batches in the USA\n - A beautiful insert describes the inspiration for the fragrance, evoking a sensory connection to Scripture\n - Signage Included\n\nOffer shoppers a one-of-a-kind, faith-based candle that honors mothers in a truly memorable way!",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:41.960Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
